export default {
  id: "averageTransactionValue",
  name: "",
  description: "",
  report: {
    name: "AVG Transaction Value",
    chartType: "NUMBER",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "Sale",
      dimensions: [],
      measures: ["Sale.avg_transaction_value"],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: false,
      limit: "1",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
